import React, { Component } from "react";
import FirstPage from "./FirstPage";
import SecondPage from "./SecondPage";
import Success from "./Success";

import "../styles/main.css";

import { parsePhoneNumberFromString as format } from "libphonenumber-js";

let search = window.location.search;
let params = new URLSearchParams(search);
let codeCoupon = params.get("code");
let successParam = params.get("success");
let classHours = params.get("class_hours");

export class B2C1to10 extends Component {
  state = {
    step: successParam ? 2 : 0,
    classGradeValues: [
      "א׳",
      "ב׳",
      "ג׳",
      "ד׳",
      "ה׳",
      "ו׳",
      "ז׳",
      "ח׳",
      "ט׳",
      "י׳",
    ],

    classValues: ["מתמטיקה", "שפה/לשון"],
    restoreClassValues: ["מתמטיקה", "שפה/לשון"],
    classSelection: "",
    classSubValues: [],
    classSubSelection: "",
    fullName: "",
    phoneNumber: "",
    validPhoneNumber: "",
    invalidPhone: false,
    gradeLevel: "",
    language: "",
    classRadio: "",
    // couponInput: codeCoupon || "",
    couponCode: codeCoupon || "",
    couponGroups: [
      ["מרכז20א"] /*249 NIS*/,
      ["מרכז20100"] /*199 NIS*/,
      ["מרכז2020"] /*149 NIS*/,
      ["ארתורהתותח123"] /*TESTING 1 NIS*/,
      //["מרכז2020", "coupon31", "coupon32"]
    ],
    tempPriceCombination: !codeCoupon ? 0 : void 0,
    priceCombination: void 0,
    couponError: false,
    openMessageModal: this.couponError ? true : false,
    success: successParam,
    classHours: classHours ? classHours : "0",
    tempClassesArray: [],
    finalClassesArray: [],
    sameClassSubclasses: [],
    enableAddNewClass: false,
    enableRemoveClass: false,
  };

  componentDidMount() {
    this.addInitialClassObject();
  }

  // adds initial object to the temp array to show initial inputs
  addInitialClassObject = () => {
    let classArr = this.state.tempClassesArray;
    classArr.push({
      index: 0,
      classValues: this.state.classValues,
      classSelection: "",
      classSubValues: [],
      classSubSelection: "",
    });
    this.setState({
      tempClassesArray: classArr,
    });
  };

  // adds new object to temp array on click + icon
  addNewClassObject = async () => {
    let classItems = [...this.state.tempClassesArray];

    const lastChosenObject = classItems[classItems.length - 1];

    if (!lastChosenObject.classSelection || !lastChosenObject) {
      await this.setState({
        enableAddNewClass: false,
      });
      return;
    }

    await this.setSubListValues(lastChosenObject.classSelection);
    if (this.state.classSubValues.length === 0) {
      await this.setState({
        classValues: this.state.classValues.filter(
          (x) => x !== lastChosenObject.classSelection
        ),
      });
    }

    let classToRemove = null;
    for (let index = 0; index < this.state.tempClassesArray.length; index++) {
      const element = this.state.tempClassesArray[index];
      if (element.classSubValues.length === 1) {
        classToRemove = element;
      }
    }

    console.log(classToRemove);
    let newClassValues = [];
    if (classToRemove) {
      newClassValues = this.state.classValues.filter(
        (x) => x !== classToRemove.classSelection
      );
      await this.setState({
        classValues: newClassValues,
      });
    }

    console.log(this.state.tempClassesArray);

    let objToAdd = {
      index: this.state.tempClassesArray.length,
      classValues: this.state.classValues,
      classSelection: "",
      classSubValues: [],
      classSubSelection: "",
    };

    classItems.push(objToAdd);
    await this.setState({
      tempClassesArray: classItems,
    });
  };

  removeClassObject = (index) => {
    let classItems = [...this.state.tempClassesArray];

    if (index > 0) {
      classItems.splice(index, 1);
      this.setState({
        tempClassesArray: classItems,
      });
    }
  };

  // Proceed to next step
  nextStep = () => {
    const { step } = this.state;
    this.setState({
      step: step + 1,
    });
  };

  // Go back to prev step
  prevStep = () => {
    const { step } = this.state;
    this.setState({
      step: step - 1,
    });
  };

  // Handle fields change
  handleChangeName = (e) => {
    this.setState({ fullName: e.target.value });
  };

  handleChangePhoneNumber = async (e) => {
    const userPhoneInput = e.target.value;
    await this.setState({
      phoneNumber: userPhoneInput,
    });

    const formattedPhone = format(userPhoneInput, "IL");

    if (formattedPhone) {
      if (formattedPhone.isValid()) {
        await this.setState({
          validPhoneNumber: formattedPhone.number,
          invalidPhone: false,
        });
      } else {
        await this.setState({
          invalidPhone: true,
        });
      }
    } else {
      await this.setState({
        invalidPhone: true,
      });
    }
  };

  handleChangeGradeLevel = async (e) => {
    await this.setState({ gradeLevel: e.target.value });
    // if (this.state.tempClassesArray.length > 1) {
    //   await this.setState({ tempClassesArray: [] });
    //   await this.addInitialClassObject();
    // }

    let classArr = [];
    classArr.push({
      index: 0,
      classValues:
        this.state.gradeLevel === "י׳"
          ? this.state.classValues
          : this.state.restoreClassValues,
      classSelection: "",
      classSubValues: [],
      classSubSelection: "",
    });
    await this.setState({
      tempClassesArray: classArr,
      classSubValues: [],
    });
  };

  handleChangeClassValues = async (e, index) => {
    let classItems = [...this.state.tempClassesArray];

    let objToChange = { ...classItems[index] };
    objToChange.classSelection = e.target.value;

    let lastObjectWithSameClass;
    for (let index = classItems.length - 1; index >= 0; index--) {
      const element = classItems[index];
      if (element.classSelection === objToChange.classSelection) {
        lastObjectWithSameClass = element;
      }
    }

    if (index === 0) {
      await this.setSubListValues(objToChange.classSelection);
      objToChange.classSubValues = this.state.classSubValues;

      classItems[index] = objToChange;
      await this.setState({
        tempClassesArray: classItems,
        enableAddNewClass: true,
        enableRemoveClass: true,
      });
      return;
    }

    if (!lastObjectWithSameClass) {
      await this.setSubListValues(objToChange.classSelection);
      objToChange.classSubValues = this.state.classSubValues;

      classItems[index] = objToChange;
      await this.setState({
        tempClassesArray: classItems,
        enableAddNewClass: true,
        enableRemoveClass: true,
      });
      return;
    }

    await this.setSubListValues(objToChange.classSelection);
    let subClasses = [];

    if (objToChange.classSelection === lastObjectWithSameClass.classSelection) {
      subClasses = this.state.classSubValues.filter(
        (x) =>
          x !== lastObjectWithSameClass.classSubSelection &&
          !this.state.sameClassSubclasses.includes(x)
      );
      objToChange.classSubValues = subClasses;
    }

    classItems[index] = objToChange;
    await this.setState({
      tempClassesArray: classItems,
      enableAddNewClass: true,
      enableRemoveClass: true,
    });
  };

  // sets the sublist values
  setSubListValues = async (value) => {
    let subListDropdown;

    if (this.state.gradeLevel !== "י׳") {
      subListDropdown = [];
      return;
    }
    switch (value) {
      case "מתמטיקה":
        subListDropdown = ['3 יח"ל', '4 יח"ל', '5 יח"ל'];
        break;
      case "שפה/לשון":
        subListDropdown = ["שאלון תורת ההגה והצורות", "שאלון תחביר"];
        break;
      default:
        break;
    }

    await this.setState({
      classSubValues: subListDropdown,
    });
  };

  // class sublist second dropdown
  handleChangeSubClassValues = async (e, index) => {
    const classItems = [...this.state.tempClassesArray];

    let objToChange = { ...classItems[index] };
    objToChange.classSubSelection = e.target.value;

    classItems[index] = objToChange;
    await this.setState({
      tempClassesArray: classItems,
    });

    let classSubclasses = [...this.state.sameClassSubclasses];
    classSubclasses.push(objToChange.classSubSelection);
    await this.setState({
      sameClassSubclasses: classSubclasses,
    });
  };

  finalizeClassSubclass = () => {
    let finalizedClassesSubclasses = [];
    this.state.tempClassesArray.forEach((element) => {
      finalizedClassesSubclasses.push({
        class: element.classSelection,
        subClass: element.classSubSelection ? element.classSubSelection : null,
      });
    });

    this.setState({
      finalClassesArray: finalizedClassesSubclasses,
    });
  };

  handleChangeLanguage = (e) => {
    this.setState({
      language: e.target.value,
    });
  };

  handleChangeClassRadio = (e) => {
    this.setState({
      classRadio: e.target.value,
    });
  };

  // // third page add coupon
  // handleChangeCoupon = async (e) => {
  //   await this.setState({ couponInput: e.target.value });
  // };

  // checking the combination to show different iframe
  checkPriceCombination = async () => {
    for (let i = 0; i < this.state.couponGroups.length; i++) {
      const couponGroup = this.state.couponGroups[i];
      if (couponGroup.includes(this.state.couponCode)) {
        await this.setState({ tempPriceCombination: i + 1 });
        break;
      }
    }

    if (
      this.state.tempPriceCombination === undefined ||
      this.state.tempPriceCombination === -1
    ) {
      await this.setState({
        tempPriceCombination: 0,
        couponError: true,
        openMessageModal: true,
      });
    }

    await this.setState({ priceCombination: this.state.tempPriceCombination });
  };

  handleModalClose = () => {
    this.setState({
      openMessageModal: false,
    });
  };

  // finish step where all data is sent to an API
  finish = async () => {
    let allValues;
    let coupon;
    // To retrive that item
    try {
      const serializedState = localStorage.getItem("state");
      const serializedcoupon = localStorage.getItem("coupon");

      if (serializedState === null) {
        return undefined;
      }
      allValues = JSON.parse(serializedState);
      coupon = JSON.parse(serializedcoupon);
    } catch (err) {
      allValues = undefined;
    }

    const {
      fullName,
      validPhoneNumber,
      gradeLevel,
      language,
      classRadio,
      finalClassesArray,
      couponCode,
    } = allValues;
    const finishValues = {
      fullName,
      validPhoneNumber,
      gradeLevel,
      language,
      classRadio,
      finalClassesArray,
      couponCode,
    };

    // NOTE: if you want all the class & subclass values added to the url as params
    let classSubclassString = "";
    finalClassesArray.forEach((element) => {
      classSubclassString += `class=${element.class}|subClass=${element.subClass},`;
    });

    console.log(classSubclassString);

    // send request to API with all the values in an object
    const Http = new XMLHttpRequest();

    // sheet resides @: https://script.google.com/a/class.me/d/1-8nfkIyBkoy2DjQAWR2JUxdqLHHHFq0ULK8eJ1zLxWOjPKR_Z2lBvTnx/edit?mid=ACjPJvEn3FfjL8cbomGagi1fxbhUrQbTy_tt6ruFT6tkC08cB2IQ4P8VL3EIbI-dwqjXFIRqXtaGLx3_tu6y6RvG6XymgM_go2B6lOkqnoPmVJSKbNitWm3UvJs0Wnsm276OHKE0atDNUd8&uiv=2
    const url = `https://script.google.com/macros/s/AKfycby80kuNu9Q4Bxa1zOGblxPB19FClUOk_zvi3esiOAVXYQZYJdr3/exec?fullName=${fullName}&userMobile=${validPhoneNumber}&gradeLevel=${finishValues.gradeLevel}&classes=${classSubclassString}&gender=${finishValues.classRadio}&language=${finishValues.language}`;
    Http.addEventListener("load", () => {
      // update the state of the component with the result here
      console.log(Http.responseText);
    });

    Http.open("GET", url);
    Http.send();
  };

  cancel = () => {
    this.setState({
      step: 0,
      fullName: "",
      phoneNumber: "",
      classSelection: "",
      gradeLevel: "",
      language: "",
      classRadio: "",
      classSubSelection: "",
      couponInput: codeCoupon || "",
      couponCode: codeCoupon || "",
    });
  };

  saveToLocalStorage = () => {
    const {
      fullName,
      validPhoneNumber,
      finalClassesArray,
      gradeLevel,
      language,
      classRadio,
      couponCode,
    } = this.state;
    const allValues = {
      fullName,
      validPhoneNumber,
      finalClassesArray,
      gradeLevel,
      language,
      classRadio,
      couponCode,
    };
    // To save the item
    try {
      const serializedState = JSON.stringify(allValues);
      localStorage.setItem("state", serializedState);
    } catch (err) {
      return undefined;
    }
    try {
      const serializedClassHour = JSON.stringify(this.state.classHours);
      localStorage.setItem("classHour", serializedClassHour);
    } catch (err) {
      return undefined;
    }
  };

  render() {
    try {
      const serializedCoupon = JSON.stringify(this.state.couponCode);
      localStorage.setItem("coupon", serializedCoupon);
    } catch (err) {
      return undefined;
    }

    const { step } = this.state;
    const {
      fullName,
      phoneNumber,
      validPhoneNumber,
      citySelection,
      copyNumberCheckbox,
      classSelection,
      classSubSelection,
      gradeLevel,
      language,
      classRadio,
    } = this.state;
    const values = {
      fullName,
      phoneNumber,
      validPhoneNumber,
      citySelection,
      classSubSelection,
      copyNumberCheckbox,
      classSelection,
      gradeLevel,
      language,
      classRadio,
    };

    let mainContent = null;

    switch (step) {
      case 0:
        mainContent = (
          <FirstPage
            handleChangePhoneNumber={this.handleChangePhoneNumber}
            validPhoneNumber={this.state.validPhoneNumber}
            invalidPhone={this.state.invalidPhone}
            handleChangeName={this.handleChangeName}
            classValues={this.state.classValues}
            nextStep={this.nextStep}
            prevStep={this.prevStep}
            values={values}
            cancel={this.cancel}
            currStep={this.state.step}
            handleChangeGradeLevel={this.handleChangeGradeLevel}
            handleChangeClassValues={this.handleChangeClassValues}
            handleChangeLanguage={this.handleChangeLanguage}
            handleChangeClassRadio={this.handleChangeClassRadio}
            classSubValues={this.state.classSubValues}
            handleChangeSubClassValues={this.handleChangeSubClassValues}
            tempClassesArray={this.state.tempClassesArray}
            addNewClassObject={this.addNewClassObject}
            finalizeClassSubclass={this.finalizeClassSubclass}
            enableAddNewClass={this.state.enableAddNewClass}
            removeClassObject={this.removeClassObject}
            enableRemoveClass={this.state.enableRemoveClass}
            classGradeValues={this.state.classGradeValues}
          />
        );
        break;

      case 1:
        mainContent = (
          <SecondPage
            nextStep={this.nextStep}
            prevStep={this.prevStep}
            values={values}
            coupon={this.state.couponCode}
            cancel={this.cancel}
            currStep={this.state.step}
            priceCombination={this.state.priceCombination}
            couponError={this.state.couponError}
            checkPriceCombination={this.checkPriceCombination}
            openMessageModal={this.state.openMessageModal}
            handleModalClose={this.handleModalClose}
            saveToLocalStorage={this.saveToLocalStorage}
            tempClassesArray={this.state.tempClassesArray}
          />
        );
        break;

      case 2:
        mainContent = (
          <Success finish={this.finish} classHours={this.state.classHours} />
        );
        break;

      default:
        console.log("Invalid step", step);
        break;
    }
    return (
      <div className="main">
        {step <= 1 ? (
          <div className="image">
            <img
              src={require("../assets/new-logo.svg")}
              alt="logo"
              width="120"
              height="40"
            />
            <p className="logo-text">ככה לומדים היום לבגרות</p>
          </div>
        ) : null}
        {mainContent}
      </div>
    );
  }
}

export default B2C1to10;
